import React from 'react';
import PropTypes from 'prop-types';
import { Price } from './price';
import { PriceIsMps } from './price_is_mps';
import { getTranslationElement } from '../../../helper/getTranslationElement';
import getTranslatedText from '../../../helper/get_translated_text';

export const ProductSingleItemPrice = props => (
    props.isMpsProduct ?
        <PriceIsMps
            name="product-single-item-price"
            label={getTranslatedText('pdp-sidebar-price-per-piece')}
            price={props.price}
            currencyIsoCode={props.currencyIsoCode}
        />
    :
        <Price
            name="product-single-item-price"
            label={getTranslationElement('pdp-sidebar-price-per-piece')}
            price={props.price}
            currencyIsoCode={props.currencyIsoCode}
        />
);

ProductSingleItemPrice.propTypes = {
    price: PropTypes.number.isRequired,
    currencyIsoCode: PropTypes.string.isRequired,
    isMpsProduct: PropTypes.bool,
};

ProductSingleItemPrice.defaultProps = {
    isMpsProduct: false,
};
